//链接
let globalVariable = {
  /* txh_gw:'http://txh-demo.com',//天下汇官网 */
  //dtqp_try_game:'http://play.datqp.com',//大唐棋牌
  dtqp_try_game:'https://play.xtqnr.com',//大唐棋牌
  txhsx_try_game:'http://tryplay.txh-demo.com',//天下汇视讯
  successStories:'https://txwl.in/',//成功案例
}

//试玩
globalVariable.tryGame = (game,type='') => {
  if(globalVariable[game]=='')return;
  window.open(globalVariable[game]+type,'_blank');
};
export default globalVariable



// WEBPACK FOOTER //
// ./src/router/globalVariable.js